import React, { useState } from 'react';
import { faBook, faFileText } from '@fortawesome/free-solid-svg-icons';
import { CreateFlowModal } from './CreateFlowModal';
import { CreateCourseModal } from './CreateCourseModal';
import { CreateContentTypeModal } from './CreateContentTypeModal';
import { SelectionCard } from './shared/SelectionCard';
import { Color } from 'core';
import styled from 'styled-components';
import { useCurrentUser } from 'hooks/useCurrentUser';

interface IProps {
  onClose: () => void;
  onSetCreated?: () => void;
}

type ModalStep = 'selection' | 'course' | 'content';

export const CreateModal = (props: IProps) => {
  const { onClose, onSetCreated } = props;
  const [currentStep, setCurrentStep] = useState<ModalStep>('selection');
  const user = useCurrentUser();

  const canCreateCourse = user?.primaryPartner?.meta?.canCreateCourse;

  const handleCourseClick = () => {
    setCurrentStep('course');
  };

  const handleContentClick = () => {
    setCurrentStep('content');
  };

  const handleBackToSelection = () => {
    setCurrentStep('selection');
  };

  if (currentStep === 'course') {
    return <CreateCourseModal onClose={onClose} onBack={handleBackToSelection} />;
  }

  if (currentStep === 'content') {
    return <CreateContentTypeModal onClose={onClose} onBack={handleBackToSelection} onSetCreated={onSetCreated} />;
  }

  return (
    <CreateFlowModal title="Create New" onClose={onClose}>
      <ModalContent>
        <SectionTitle>Select what you'd like to create</SectionTitle>
        <CardsContainer>
          <SelectionCard
            title="Course"
            description="Create a new course to organize related content"
            icon={faBook}
            iconColor="#4a69bd"
            iconBackgroundColor="#dde7ff"
            onClick={handleCourseClick}
            disabled={!canCreateCourse}
            tooltipText={!canCreateCourse ? 'Only admins and course managers can create courses' : undefined}
          />
          <SelectionCard
            title="Content"
            description="Create content for learning and assessment"
            icon={faFileText}
            iconColor="#27ae60"
            iconBackgroundColor="#d4f4dd"
            onClick={handleContentClick}
          />
        </CardsContainer>
      </ModalContent>
    </CreateFlowModal>
  );
};

const ModalContent = styled.div`
  padding: 20px;
`;

const SectionTitle = styled.h3`
  text-align: center;
  color: ${Color.darkGray};
  margin: 0 0 40px 0;
  font-weight: 400;
  font-size: 20px;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;
